/**
 * Marqueur pose a cote du pseudo d'un adversaire automatique.
 *
 * Le jeu ne cherche jamais a faire croire que le bot est un joueur : son pseudo
 * est genere comme celui de n'importe qui, mais ce marqueur le suit partout ou
 * son nom s'affiche (salon, scores, podium). L'icone est decorative, le sens
 * est porte par le titre accessible.
 */
import type { ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { RobotIcon } from './icons.js';

export function BotTag({ size = 14 }: { readonly size?: number }): ReactElement {
  const t = useT();
  return (
    <span className="bot-tag" title={t('common.bot')}>
      <RobotIcon size={size} />
      <span className="visually-hidden">{t('common.bot')}</span>
    </span>
  );
}
